export default __webpack_public_path__ + "static/media/Przelewy24_logo.01d8f9fd.png";